<template>
    <div class="shopCategories flex wrap">
        <div 
            class="shopCategoriesItem flex align-center" 
            v-for="shop in shopList" :key="shop.id"
        >
            <div class="shopCategoriesItemShop flex align-center">
                <el-image
                    :src="shop.icon"
                    style="width: 26px; height: 26px;  border-radius: 50%"
                ></el-image>
                <span class="shop-title">{{ shop.shortTitle || shop.title }}</span>
            </div>
            <el-select
                v-model="valueMap[shop.id]"
                :loading="loading[shop.id]"
                filterable
                multiple
                @change="(val) => handleSelect(shop.id, val)"
                @visible-change="e => selectVisible(shop.id, e)"
            >
                <el-option
                    v-for="brandOp in categoriesOptions[shop.id]"
                    :key="brandOp.id"
                    :label="brandOp.name"
                    :value="brandOp.id">
                </el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
import { getJdmsShopCategory } from '@/servers/prod/center/jdms.js'
import { cloneDeep } from 'lodash';

export default {
    name: 'jdmsShopCategories',
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        shopList: {
            type: Array,
            default() {
                return []
            }
        },
        value: {
            type: Array,
            default() {
                return []
            }
        },
        baseItemId: [String, Number],
    },
    data() {
        return {
            valueMap: {},
            originOptions: {},
            categoriesOptions: {},
            loading: {},
            getFail: {},
            categoryId: '',
            shopDialogVisible:false,
            selectShopIds: '',
        }
    },
    watch: {
        value: {
            handler(v) {
                let map = {};
                v.forEach(item => {
                    let val = []
                    let shopId = item.shopId;
                    let optArr = []
                    item.cateList.forEach(c => {
                        let obj = {
                            id:c.shopCategoryId,
                            name:c.name
                        }
                        optArr.push(obj);
                        val.push(c.shopCategoryId)
                    })
                    if(!this.categoriesOptions[shopId]){
                        this.$set(this.categoriesOptions, shopId, optArr);
                    }
                    map[item.shopId] = val
                });
                this.$set(this, 'valueMap', map);
            },
            immediate: true,
        },
    },
    methods: {
        handleSelect(shopId){
            let list = []
            let categoriesOptions = this.categoriesOptions;
            for(let k in this.valueMap) {
                let options = categoriesOptions[k]
                let val = this.valueMap[k];
                let arr = []
                if(val.length){
                    val.forEach(_id => {
                        let name = options.find(o => o.id === _id)?.name
                        arr.push({
                            name: name,
                            shopCategoryId: _id
                        })
                    })
                    list.push({
                        shopId: k,
                        cateList: arr
                    })
                }
            }
            this.$emit('change', list)
        },
        selectVisible(shopId, visible) {
            if(visible) {
                if (!this.categoriesOptions[shopId]) {
                    this.getShopCategoriesList(shopId)
                }
            } else {
                if (this.originOptions[shopId]) {
                    this.categoriesOptions[shopId] = cloneDeep(this.originOptions[shopId]);
                }
            }
        },
        async getShopCategoriesList(id) {
            this.$set(this.loading, id, true)
            this.getFail = {};
            try {
                let list = await getJdmsShopCategory(id)
                // let list = await getVenderBrandListByshopId({shopId: id, categoryId: this.categoryId, brandName})
                this.loading[id] = false;
                if (!list) {
                    this.$set(this.getFail, id, true)
                    list = []
                } else {
                    list = list.map(item => {
                        return {
                            shopId: id,
                            id: item.id,
                            name: item.shopCategoryName
                        }
                    })
                }
                this.$set(this.categoriesOptions, id, cloneDeep(list))
                this.$set(this.originOptions, id, cloneDeep(list))
            } catch (error) {
                console.log(error, '-----error')
            }
            
        },
    },
}
</script>

<style lang="scss" scoped>
.shopCategoriesItem{
    width: 50%;
    margin-bottom: 10px;
}
</style>